import { config } from '../../../config'
import { loadScript } from '../../../helpers/common'

const mapGoogleNetworksToProhibitedCard = {
  AMEX: 'AmEx',
  MASTERCARD: 'MasterCard',
  VISA: 'Visa',
}

class GooglePayAdapter {
  #GOOGLE_PAY_ENV = {
    TEST: 'TEST',
    PRODUCTION: 'PRODUCTION',
  }

  #baseRequest = {
    apiVersion: 2,
    apiVersionMinor: 0,
  }

  #allowedCardNetworks = ['AMEX', 'MASTERCARD', 'VISA']

  #baseCardPaymentMethod = {
    type: 'CARD',
    parameters: {
      allowedAuthMethods: ['CRYPTOGRAM_3DS'],
      allowedCardNetworks: this.#allowedCardNetworks,
    },
  }

  #paymentsClient

  #paymentConfig

  constructor() {
    this.#paymentConfig = {
      merchantId: null,
      merchantName: null,
      gateway: null,
      gatewayMerchantId: null,
      currencyCode: null,
      transactionId: null,
      countryCode: null,
      totalPrice: null,
    }

    this.enviroment =
      this.#GOOGLE_PAY_ENV[config.googlePayEnv] || this.#GOOGLE_PAY_ENV.TEST

    if (this.enviroment === this.#GOOGLE_PAY_ENV.TEST) {
      this.#baseCardPaymentMethod.parameters.allowedAuthMethods = [
        'PAN_ONLY',
        'CRYPTOGRAM_3DS',
      ]
    }

    this.isInitialised = false
  }

  updateTotalPrice(updatedPrice) {
    this.#paymentConfig.totalPrice = updatedPrice
  }

  updatePaymentConfig(updatedConfig) {
    this.#paymentConfig = {
      ...this.#paymentConfig,
      ...updatedConfig,
    }
  }

  setProhibitedCardNetworks(prohibitedCardNetworks = []) {
    this.#baseCardPaymentMethod.parameters.allowedCardNetworks =
      this.#allowedCardNetworks.filter(
        network =>
          !prohibitedCardNetworks.includes(
            mapGoogleNetworksToProhibitedCard[network],
          ),
      )
  }

  loadGooglePayScript() {
    return new Promise((resolve, reject) => {
      loadScript(
        config.googlePayURL,
        () => {
          this.#paymentsClient = new google.payments.api.PaymentsClient({
            environment: this.enviroment,
          })
          this.isInitialised = true
          resolve()
        },
        () => {
          console.error('Loading Google Pay script error')
          reject()
        },
      )
    })
  }

  isReadyToPay() {
    return this.#paymentsClient
      .isReadyToPay(this.#getGoogleIsReadyToPayRequest())
      .then(response => !!response.result)
      .catch(err => console.error(err))
  }

  #getGoogleIsReadyToPayRequest() {
    return {
      ...this.#baseRequest,
      ...{
        allowedPaymentMethods: [this.#baseCardPaymentMethod],
      },
    }
  }

  getGooglePaymentDataRequest() {
    return {
      ...this.#baseRequest,
      allowedPaymentMethods: [
        {
          ...this.#baseCardPaymentMethod,
          ...{
            tokenizationSpecification: {
              type: 'PAYMENT_GATEWAY',
              parameters: {
                gateway: this.#paymentConfig.gateway,
                gatewayMerchantId: this.#paymentConfig.gatewayMerchantId,
              },
            },
          },
        },
      ],
      transactionInfo: this.#getGoogleTransactionInfo(),
      merchantInfo: {
        merchantName: this.#paymentConfig.merchantName,
        merchantId: this.#paymentConfig.merchantId,
      },
    }
  }

  #getGoogleTransactionInfo() {
    return {
      totalPriceLabel: 'Total',
      totalPriceStatus: 'FINAL',
      countryCode: this.#paymentConfig.countryCode,
      currencyCode: this.#paymentConfig.currencyCode,
      transactionId: this.#paymentConfig.transactionId,
      totalPrice: this.#paymentConfig.totalPrice,
    }
  }
}

export default new GooglePayAdapter()
